import * as React from "react";
import { Button } from "./styles";

interface InterfaceButton {
  children: any;
  onClick: () => void;
}

export default class DefaultButton extends React.Component<InterfaceButton> {
  public render() {
    const { children, ...restProps } = this.props;

    return <Button {...restProps}>{children}</Button>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/index.tsx